import { addStyles, DefaultTheme } from '../../components/theme';
import { ColorPaletteOrange, WHITE } from '../../components/theme.palette';
import { CSS as TableCSS } from './dashboard.table.style';

//these colours are on the advice of marketing team.
const orangeFull = 'rgba(255, 131, 0, 1)';
//const orangeTrans = 'rgba(255, 131, 0, .1)';

const redFull = 'rgba(224, 69, 4, 1)';
//const redTrans = 'rgba(224, 69, 4, .1)';

//const yellowFull = 'rgba(255, 198, 41, 1)';
//const yellowTrans = 'rgba(255, 198, 41, .1)';

const greyFull = 'rgba(208, 207, 205, 1)';
const greyTrans = 'rgba(208, 207, 205, .25)';

export const MDL = {
	button: 'mdl-button',
	title: 'mdl-layout-title',
	spacer: 'mdl-layout-spacer',
	drawer: {
		button: 'mdl-layout__drawer-button',
	},
};

export const CSS = {
	container: 'c-Dashboard',
	title: 'c-Dashboard__title',
	message: 'c-Dashboard__message',
	tableCell: 'c-Dashboard__TableCell',
	tableCellFaint: 'c-Dashboard__TableCell--faint',
	tableCellGhost: 'c-Dashboard__TableCell--ghost',
	tableCellRoleActions: 'c-Dashboard__TableCellRole',
};

export const Banner = {
	header: {
		container: 'c-Dash-Header',
		row: 'c-Dash-Header_row',
		section: 'c-Dash-Header__section',
	},
	menuButton: {
		span: 'c-Dash-Span',
		spanSelected: 'c-Dash-Span__selected',
	},
};

addStyles({
	[TableCSS.header]: {
		['& .mdl-data-table__cell--non-numeric']: {
			'white-space': 'normal',
		},
	},
	[CSS.container]: {
		width: '95%',
		margin: 'auto',
		'box-shadow': DefaultTheme.shadow.box.dp2,
		'padding-bottom': '5px',
		[`& .${TableCSS.container}`]: {
			border: 0,
			'table-layout': 'fixed',
			'& th': {
				position: 'sticky',
				top: '0',
				'z-index': '10',
				color: 'black',
			},
			['& thead']: {
				['& th']: {
					width: '100%',
					'background-color': greyFull,
				},
				['& .execHeader1']: {
					'background-color': redFull,
					width: '100%',
				},
				['& .execHeader0']: {
					'background-color': orangeFull,
					width: '100%',
				},
				'& td:first-of-type, & th:first-of-type': {
					width: 'min-content',
					'min-width': 'min-content',
					'background-color': greyFull,
				},
				'& td:nth-of-type(2), & th:nth-of-type(2)': {
					width: '250px',
					'white-space': 'normal',
					'background-color': greyFull,
				},
			},
			'& td': {},
			'& td:first-of-type, & th:first-of-type': {
				width: 'min-content',
				'min-width': 'min-content',
			},
			'& td:nth-of-type(2), & th:nth-of-type(2)': {
				width: '250px',
				'white-space': 'normal',
			},
			['& .execHeader1']: {
				'background-color': greyTrans,
				'& span': {
					'background-color': 'rgba(0,0,0,0)',
				},
			},
			['& .execHeader0']: {
				'& span': {
					'background-color': 'rgba(0,0,0,0)',
				},
			},
		},
	},
	[CSS.title]: {
		padding: '0 ' + DefaultTheme.space(6),
		height: DefaultTheme.space(12),
		'line-height': DefaultTheme.space(12),
		display: 'flex',
		'& h6': {
			margin: 0,
			'line-height': DefaultTheme.space(12),
		},
	},
	[CSS.message]: {
		padding: DefaultTheme.space(6),
	},
	[CSS.tableCellFaint]: {
		color: DefaultTheme.font.color.supporting,
	},
	[`${TableCSS.row}:hover .${CSS.tableCellGhost}`]: {
		visibility: 'visible',
	},
	[CSS.tableCellGhost]: {
		visibility: 'hidden',
	},
	[CSS.tableCellRoleActions]: {
		display: 'flex',
		'align-items': 'center',
		'justify-content': 'space-between',
		width: '100%',
	},
	[Banner.menuButton.span]: {
		margin: `0 ${DefaultTheme.space(2)}`,
		'font-weight': DefaultTheme.font.weight.normal,
		overflow: 'hidden',
		'white-space': 'nowrap',
		'text-overflow': 'ellipsis',
	},
	[Banner.menuButton.spanSelected]: {
		margin: `0 ${DefaultTheme.space(2)}`,
		color: `rgb(${ColorPaletteOrange.C300})`,
		'font-weight': DefaultTheme.font.weight.normal,
		overflow: 'hidden',
		'white-space': 'nowrap',
		'text-overflow': 'ellipsis',
	},
	[Banner.header.container]: {
		height: DefaultTheme.space(10),
		'min-height': DefaultTheme.space(10),
		width: '100%',
	},
	[Banner.header.row]: {
		display: 'flex',
		'flex-direction': 'row',
		'align-items': 'center',
		height: DefaultTheme.space(10),
		'padding-left': DefaultTheme.space(14),
		'padding-right': DefaultTheme.space(2),
		'min-height': DefaultTheme.space(10),
		color: `rgb(${WHITE})`,
		[`& .${MDL.title}`]: {
			'white-space': 'nowrap',
			'margin-right': DefaultTheme.space(2),
		},
		'& i': {},
	},
	[Banner.header.section]: {
		display: 'flex',
		flex: 1,
		'align-items': 'center',
	},
});
